// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TeamScore {
  display: flex;
  flex-direction: column;
  align-items: center; }
  .TeamScore .score {
    text-align: center;
    margin-bottom: 0; }
`, "",{"version":3,"sources":["webpack://./src/components/TeamScore.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAA;EAHrB;IAMI,kBAAkB;IAClB,gBAAgB,EAAA","sourcesContent":[".TeamScore {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  .score {\n    text-align: center;\n    margin-bottom: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
